import type {GetLead_lead as Lead} from 'nutshell-graphql-types';

import {useLeadBackboneWatch} from './graphql/hooks';

type Props = {
    lead: Lead;
};

/**
 * This component's only purpose is to call the `useLeadBackboneWatch` hook. It
 * does not render any UI.
 *
 * This is necessary because the `useLeadBackboneWatch` hook's `id` parameter is
 * non-optional, but the `LeadPage` component will not always have a lead ID.
 * Although React hooks cannot be conditionally called, they can be put into a
 * component that is conditionally rendered, which is what we're doing here.
 */
export function LeadBackboneWatcher(props: Props) {
    useLeadBackboneWatch(props.lead.id);

    return null;
}
